import { http } from './config'

export default {

  getOrdersIndicatores: (date, locality_id) => {
    return http.get(`indicators/today_orders?date=${date}&locality_id=${locality_id}`)
  },

  getVehiclesIndicatores: (date, locality_id) => {
    return http.get(`indicators/today_vehicles?date=${date}&locality_id=${locality_id}`)
  },

  getAssembled: (date, locality_id) => {
    return http.get(`indicators/today_assembleds?date=${date}&locality_id=${locality_id}`)
  },

  getChecked: (date, locality_id) => {
    return http.get(`indicators/today_checkeds?date=${date}&locality_id=${locality_id}`)
  },

  getStacked: (date, locality_id) => {
    return http.get(`indicators/today_stackeds?date=${date}&locality_id=${locality_id}`)
  },

  getOrdersApprovedAndRefused: (date, locality_id) => {
    return http.get(`indicators/last_orders_aproved_and_refused?date=${date}&locality_id=${locality_id}`)
  },

  getLastOrdersErrors: (date, locality_id) => {
    return http.get(`indicators/last_order_errors?date=${date}&locality_id=${locality_id}`)
  },

  getLastBoxesAndWeight: (date, locality_id) => {
    return http.get(`indicators/last_boxes_and_weight?date=${date}&locality_id=${locality_id}`)
  },

  getProductsByBoxes: (operation_id) => {
    return http.get(`indicators/products_by_boxes?operation_id=${operation_id}`)
  },

  getProductsByPallets: (operation_id) => {
    return http.get(`indicators/products_by_pallets?operation_id=${operation_id}`)
  },

  exportProductsByBoxesReport: (operation_id) => {
    return http.get(`indicators/export_products_by_boxes_report?operation_id=${operation_id}`)
  },
  
  exportProductsByPalletsReport: (operation_id) => {
    return http.get(`indicators/export_products_by_pallets_report?operation_id=${operation_id}`)
  },

}
